/*
  The following module contains error codes and message maps returned by Shishito.

  Should this module become to large, we will break up the contents of this module by domain and nest them under "errors/".
*/

export enum UpdateEmployeeValidationCodes {
  LOGIN_EMAIL_EXISTS = 'LOGIN_EMAIL_EXISTS',
  PHONE_NUMBER_EXISTS = 'PHONE_NUMBER_EXISTS',
  UPDATE_EMPLOYEE_INVALID_EMAIL = 'UPDATE_EMPLOYEE_INVALID_EMAIL',
}

export enum SalesRepPriceValidationErrorCode {
  SALES_REP_PRICE_TOO_HIGH = 'SALES_REP_PRICE_TOO_HIGH',
  SALES_REP_PRICE_TOO_LOW = 'SALES_REP_PRICE_TOO_LOW',
}

export enum SalesRepGrossProfitValidationErrorCode {
  SALES_REP_GROSS_PROFIT_TOO_HIGH = 'SALES_REP_GROSS_PROFIT_TOO_HIGH',
}

export enum InviteEmployeeErrorCode {
  INVITE_EMPLOYEE_PHONE_EMAIL_CONFLICT = 'INVITE_EMPLOYEE_PHONE_EMAIL_CONFLICT',
}
